<template>
    <div class="pay-box" @click="onClose">
        <div class="base-yx-pay" :class="{ 'yxpay-sp': $store.state.screen == 1 }" @click.stop>
            <div class="content">
                <div class="header">
                    <div class="back-img" @click="onClose">
                        <img class="back" src="~images/back.png" />
                    </div>
                    <div class="title">支付h5</div>
                    <div class="service-img" @click="toSer">
                        <img class="ser" src="~images/user_service.png" />
                    </div>
                </div>
                <div class="content-auto" v-show="is_monthcard != null">
                    <div class="pay-info">
                        <div class="money">需支付：
                            <span>
                                <span class="num" v-if="ispay != 2">
                                    <span v-if="monthcard_id"> {{ computedPrice(amount - isDiscount + monthcard_money)
                                        ||
                                        computedPrice(origPrice - isDiscount + monthcard_money)}}</span>
                                    <span v-else>{{ computedPrice(amount - isDiscount) || computedPrice(origPrice -
                                        isDiscount) }}</span>
                                </span>
                                <span class="num" v-if="ispay == 2">
                                    <span v-if="monthcard_id">{{ computedPrice((amount - isDiscount + monthcard_money) /
                                        platform_ratio) || computedPrice((origPrice - isDiscount + monthcard_money) /
                                            platform_ratio) }}</span>
                                    <span v-else>{{ computedPrice((amount - isDiscount) / platform_ratio)
                                        || computedPrice((origPrice - isDiscount) / platform_ratio) }}</span>
                                </span>
                                <span v-if="ispay == 0 || ispay == 1">元</span>
                                <span v-if="ispay == 2">平台币</span>
                            </span>
                        </div>
                        <div class="info">
                            <div class="list">
                                <div class="left">商品名称</div>
                                <div class="right">
                                    <div class="productName">{{ payParams.productNAME }}</div>
                                </div>
                            </div>
                            <div class="list">
                                <div class="left">商品价格</div>
                                <div class="right">￥{{ computedPrice(origPrice) }}
                                    <span
                                        v-if="(loginData.discount && loginData.discount != 10) || discount && discount != 10">
                                        （{{ loginData.discount || discount }}折）
                                    </span>
                                </div>
                            </div>
                            <div class="list" @click="toVoucher">
                                <div class="left">代金券</div>
                                <div class="right">
                                    <div :class="{ voucher: voucher == null }">{{ fsDiscount || '暂无可用代金券' }}</div>
                                    <img src="~images/move.png" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card" @click="onSel" v-if="is_monthcard == 0">
                        <div class="name">福利月卡</div>
                        <div class="info">
                            <div class="info-left">
                                <div class="title">购买月卡，本单立减6元</div>
                                <div class="sub">一次购买连送30天，总计送券180元</div>
                            </div>
                            <div class="info-right">
                                <div class="money">￥<span>{{ monthcard_money }}</span></div>
                                <div class="sel" :class="{ isselbor: issel }">
                                    <img src="~images/sel.png" v-show="issel" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="problem">
                        <div class="line"></div>
                        <div>请选择支付方式</div>
                    </div>
                    <div>
                        <div class="pay-list" v-for="(item, index) in payList" :key="index" @click="onSelPay(index)">
                            <div class="pay-left">
                                <img :src="item.img" />
                                <span>
                                    <span v-if="index < 2">{{ item.name }}</span>
                                    <span :class="{ hscolor: index == 2 && (platform_money < paymoney) }" v-else>{{
                                        item.name }}（余额：{{ platform_money }}）</span>
                                </span>
                            </div>
                            <div>
                                <div class="no-money" v-if="index == 2 && (platform_money < paymoney)">余额不足</div>
                                <div class="pay-right" :class="{ isbor: ispay == index }" v-else>
                                    <img src="~images/sel.png" v-show="ispay == index" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <transition name="component-fade" mode="out-in">
                        <BaseYxRealName @childYxRealName='childYxRealName' v-if="isrealname" />
                        <BasePassword @childPwd='childPwd' v-if="ispaypwd" />
                        <TheTips :msg='msg' v-if="msg" />
                    </transition>
                </div>
            </div>
            <div class="btn" @click="onPay">立即支付</div>
        </div>
    </div>
</template>

<script>
import BaseYxRealName from './BaseYxRealName'
import BasePassword from './BasePassword'
import TheTips from '@/components/TheTips'

export default {
    name: 'BaseYxPay',
    components: {
        BaseYxRealName,
        BasePassword,
        TheTips
    },
    data() {
        return {
            msg: null,
            voucher: null,
            issel: false,
            payList: [
                {
                    img: require('images/pay_1_1.png'),
                    name: '支付宝（推荐）',
                    id: 2
                },
                {
                    img: require('images/pay_2_1.png'),
                    name: '微信支付',
                    id: 4
                },
                {
                    img: require('images/pay_3_1.png'),
                    name: '平台币',
                    id: 10
                }
            ],
            ispay: 0,
            isrealname: false,
            ispaypwd: false,
            payPwd: 0,
            loginData: {},
            platform_money: 0,
            payParams: {},
            amount: 0,
            discount: 0,
            origPrice: 0,
            appUid: '',
            uid: '',
            appid: '',
            channel: '',
            appkey: '',
            orderID: '',
            times: null,
            is_auth: 1,
            platform_ratio: 1,
            is_monthcard: null,
            monthcard_id: null,
            monthcard_money: null,
            voucher_id: null,
            fsDiscount: null,
            isDiscount: 0,
            monthid: null,
            payStatus: true,
            paymoney: 0,
            monthcard_first: null,
            isCloudPlay: 0,//云玩1:是云玩,0不是云玩
        }
    },
    methods: {
        computedPrice(num) {
            let count = Math.ceil(num * 100) / 100
            return count
        },
        toSer() {
            clearInterval(this.times)
            sessionStorage.removeItem('orderID')
            sessionStorage.removeItem('payType')
            this.$router.push('/base-service?appid=' + this.appid + '&channel=' + this.channel + '&uid=' + this.uid + '&appkey=' + this.appkey)
        },
        toVoucher() {
            this.$router.push('/base-yx-voucher?appid=' + this.appid + '&channel=' + this.channel + '&uid=' + this.uid + '&appkey=' + this.appkey + '&paymoney=' + this.paymoney)
        },
        onSelPay(index) {
            // 平台币不足不能选择平台币支付
            if (index == 2 && (this.platform_money < this.amount || this.platform_money < this.origPrice)) {
                return false
            }
            this.ispay = index
            sessionStorage.setItem('payType', this.ispay)
        },
        // 关闭支付页面
        onClose() {
            let that = this
            clearInterval(that.times)
            sessionStorage.clear()
            if (that.config.system == 1) {
                window.Android.closePay(false, that.orderID)
            } else if (that.config.system == 2) {
                window.webkit.messageHandlers.wz_callOC.postMessage({
                    method: 'closePay',
                    param: {
                        payState: false,
                        payId: that.orderID
                    }
                })
            }
        },
        // 关闭弹窗
        childYxRealName(event) {
            this.isrealname = event
        },
        childPwd(event) {
            // 关闭弹窗
            this.ispaypwd = false
            if (event == 1) {
                if (this.payStatus == true) {
                    this.payStatus = false
                    this.payReady()
                }
            }
        },
        // 选择月卡
        onSel() {
            this.issel = !this.issel
            if (this.issel == true) {
                this.fsDiscount = '-￥' + this.monthcard_first
                this.isDiscount = this.monthcard_first
                this.monthcard_id = this.monthid
                this.voucher_id = null
                this.paymoney = this.amount ? this.amount - this.isDiscount + this.monthcard_money : this.origPrice - this.isDiscount + this.monthcard_money
            } else {
                this.fsDiscount = this.voucher ? '-￥' + this.voucher.money : null
                this.isDiscount = this.voucher ? Number.parseInt(this.voucher.money) : 0
                this.monthcard_id = null
                this.voucher_id = this.voucher ? this.voucher.id : null
                this.paymoney = this.amount ? this.amount - this.isDiscount : this.origPrice - this.isDiscount
            }
            if (this.ispay == 2) {
                this.paymoney = this.paymoney / this.platform_ratio
            }
        },
        // 支付前检查
        onPay() {
            if (this.is_auth == 0) {
                // 需要实名
                this.isrealname = true
                return false
            }
            if (this.ispay == 2 && this.payPwd == 1) {
                this.ispaypwd = true
                return false
            }
            if (this.payStatus == true) {
                this.payStatus = false
                this.payReady()
            }
        },
        // 支付前验证
        payReady() {
            let options = {
                appid: this.appid,
                uid: this.uid
            }
            options.sign = this.util.getSign(options, this.appkey)
            // 支付前验证
            this.$axios.post('http://sdk.gameschain.pro/index.php?g=api&m=pay&a=payReady', this.$qs.stringify(options)).then(res => {
                if (res.data.status == 1) {
                    this.payStart()
                } else {
                    this.msg = res.data.msg
                    setTimeout(() => {
                        this.msg = null
                    }, 2000)
                }
            }).
                catch(o => {
                    this.msg = '请求失败'
                    setTimeout(() => {
                        this.msg = null
                    }, 2000)
                })
        },
        // 开始支付
        payStart() {
            let paymoney = typeof this.paymoney == 'number' ? this.paymoney : JSON.parse(this.paymoney)
            let payNum = this.appid == 1000 ? 3 : 1
            let options = {
                deviceType: this.config.system, // 2苹果，1安卓
                appid: this.appid,
                channel: this.channel, // 渠道
                uid: this.uid, // 用户ID
                app_uid: this.appUid, // 小号ID
                serverID: this.payParams.serverID, // 区服ID
                serverNAME: this.payParams.serverNAME, // 区服名
                roleID: this.payParams.roleID, // 角色ID
                roleNAME: this.payParams.roleNAME, // 角色名
                productID: this.payParams.productID, // 产品ID
                productNAME: this.payParams.productNAME, // 产品名
                payType: this.payList[this.ispay].id, // 支付方式
                payMode: payNum, // 充值类型(1正常充值 2GM权限充值 3平台币充值)
                monthcard_id: this.monthcard_id, // 月卡id
                voucher_id: this.voucher_id, // 代金券id
                // cardID: '', // 充值卡号
                // cardPass: '', // 充值密码
                // cardMoney: '', // 充值卡金额
                amount: this.amount, // 充值金额
                real_amount: this.paymoney,
                // origPrice: payParams.origPrice, // 原价(从研发获取,折扣服才有值,没有传0)
                extend: this.payParams.extension // 扩展字段
            }

            options.sign = this.util.getSign(options, this.appkey)
            options.origPrice = this.payParams.origPrice // 原价(从研发获取,折扣服才有值,没有传0)
            if (this.config.system == 1) {
                options.android_id = this.$route.query.androidId ? this.$route.query.androidId : this.loginData.machine_id // 安卓ID(不进入签名)
                options.imei = this.$route.query.machineCode ? this.$route.query.machineCode : this.loginData.machine_code // 安卓设备号(不进入签名)
            }
            this.$axios.post('http://sdk.gameschain.pro/index.php?g=api&m=pay&a=payStart', this.$qs.stringify(options)).then(res => {
                if (res.data.status == 1) {
                    this.orderID = res.data.data.orderID
                    sessionStorage.setItem('orderID', this.orderID)
                    // 平台币
                    if (this.ispay == 2) {
                        this.times = setInterval(() => {
                            this.payQuery()
                        }, 500)
                    } else {
                        // 支付宝微信   
                        if (res.data.data.url) {
                            if (this.ispay != 2) {
                                if (this.isCloudPlay == 1) {
                                    // 云玩支付
                                    this.msg = '云玩支付测试'
                                    setTimeout(() => {
                                        this.msg = null
                                        // 云玩支付
                                        window.Android.onCloudPlayPay(res.data.data.url, res.data.data.amount, res.data.data.orderID)

                                    }, 2000)
                                } else {
                                    location.href = res.data.data.url + '&money=' + res.data.data.amount + '&order=' + res.data.data.orderID
                                }
                            }
                        }
                    }
                } else {
                    this.msg = res.data.msg
                    setTimeout(() => {
                        this.msg = null
                    }, 2000)
                }
            }).
                catch(o => {
                    this.msg = '请求失败'
                    setTimeout(() => {
                        this.msg = null
                    }, 2000)
                })
        },
        // 支付查询
        payQuery() {
            let options = {
                // uid: this.uid,
                orderID: this.orderID
            }
            let payNum = this.appid == 1000 ? 3 : 1
            options.sign = this.util.getSign(options, this.appkey)
            options.payMode = payNum
            this.$axios.post('http://sdk.gameschain.pro/index.php?g=api&m=pay&a=payQuery', this.$qs.stringify(options)).then(res => {
                if (res.data.status == 1) {
                    this.payStatus = true
                    // 1 成功, 2 发货中, 3 未支付
                    if (res.data.data.order_status == 1) {
                        clearInterval(this.times)
                        // 成功
                        this.paySucceed()
                        if (this.ispay != 0) {
                            this.$router.push('/base-pay-success?order=' + this.orderID + '&type=' + this.ispay + '&money=' + res.data.data.money + '&time=' + res.data.data.time)
                        }
                    } else {
                        // 未支付
                        this.payError()
                    }
                }
            })
        },
        // 支付成功
        paySucceed() {
            if (this.config.system == 1) {
                window.Android.onPaySucceed()
            } else if (this.config.system == 2) {
                window.webkit.messageHandlers.wz_callOC.postMessage({ method: 'onPaySucceed' })
            }
        },
        // 支付失败
        payError() {
            if (this.config.system == 1) {
                // window.Android.onPayFail('')
            } else if (this.config.system == 2) {
                window.webkit.messageHandlers.wz_callOC.postMessage({
                    method: 'onPayFail',
                    param: {
                        message: ''
                    }
                })
            }
        },
        // 获取用户信息
        getUser() {
            let options = {
                uid: this.uid,
                appid: this.appid
            };
            options.sign = this.util.getSign(options)
            this.$axios.post('http://sdk.gameschain.pro/index.php?g=api&m=userbox&a=user_center_sdk', this.$qs.stringify(options)).then(res => {
                if (res.data.status == 1) {
                    this.platform_money = res.data.data.platform_money
                    this.is_auth = res.data.data.is_auth
                    this.payPwd = res.data.data.is_pay_pass
                    this.platform_ratio = res.data.data.platform_ratio
                    this.is_monthcard = res.data.data.is_monthcard
                    this.monthid = res.data.data.monthcard.id
                    this.monthcard_money = res.data.data.monthcard.money
                    this.monthcard_first = res.data.data.monthcard_first
                    sessionStorage.setItem('setUserData', JSON.stringify(res.data.data))
                }
            })
        }
    },
    created() {
        let that = this

        let Base64 = require('js-base64').Base64

        let appid = that.$route.query.appid ? that.$route.query.appid : that.$route.query.appId
        let appkey = that.$route.query.appkey ? that.$route.query.appkey : that.$route.query.appKey

        if (sessionStorage.getItem('setUserData')) {
            let setUserData = JSON.parse(sessionStorage.getItem('setUserData'))
            that.platform_money = setUserData.platform_money
            that.is_auth = setUserData.is_auth
            that.payPwd = setUserData.is_pay_pass
            that.platform_ratio = setUserData.platform_ratio
            that.is_monthcard = setUserData.is_monthcard
            that.monthid = setUserData.monthcard.id
            that.monthcard_money = setUserData.monthcard.money
            that.monthcard_first = setUserData.monthcard_first
        }

        let obj = {
            uid: that.$route.query.uid,
            cuid: that.$route.query.cuid,
            appid: appid,
            appkey: appkey,
            channel: that.$route.query.channel,
            system: that.$route.query.system,
            coinEnable: that.$route.query.coinEnable,
            // isHasBox 0、未安装app 1、已安装app
            isHasBox: this.$route.query.isHasBox,
            // 厂商
            maker: that.$route.query.maker,
            // 手机类型
            mobile_model: that.$route.query.mobileModel,
            // 手机设备号
            machine_code: that.$route.query.machine_code,
            // 设备ID
            machine_id: that.$route.query.androidId,
            // 系统版本
            system_version: that.$route.query.versionName,
            // 广告图片跳转链接
            getAdLinkUrl: that.$route.query.adLinkUrl,
            // 广告图片地址
            getAdImageUrl: that.$route.query.adImageUrl,
            // 是否显示广告图片
            // isDisplayAd: allUrlParams.isDisplayAd,
            // 是否开启注册
            isRegisterEnabled: that.$route.query.registerEnabled,
            // 是否开启实名认证
            isNameAuthEnabled: that.$route.query.nameAuthEnabled,
            // 是否显示平台币和平台币支付
            isPlatformMoneyEnabled: that.$route.query.platformMoneyEnabled,
            // 是否开启绑定手机
            isBindMobileEnabled: that.$route.query.bindMobileEnabled,
            // 折扣
            discount: that.$route.query.discount,
            // 云玩
            isCloudPlay:this.$route.query.isCloudPlay

        }
        // 进入支付页面存储url参数
        if (that.$route.query.uid || appid) {
            sessionStorage.setItem('accountData', JSON.stringify(obj))
        }

        this.isCloudPlay= this.$route.query.isCloudPlay&&this.$route.query.isCloudPlay==1?1:0   

        if (sessionStorage.getItem('voucher')) {
            that.voucher = JSON.parse(sessionStorage.getItem('voucher'))
            that.voucher_id = that.voucher.id
            that.fsDiscount = '-￥' + that.voucher.money
            that.isDiscount = Number.parseInt(that.voucher.money)
        }

        that.loginData = {
            uid: that.$route.query.uid,
            cuid: that.$route.query.cuid,
            appid: appid,
            appkey: appkey,
            channel: that.$route.query.channel
        }
        if (sessionStorage.getItem('loginData')) {
            let dis = JSON.parse(sessionStorage.getItem('loginData'))
            that.loginData.discount = dis.discount ? dis.discount : 0
        } else {
            that.loginData.discount = 0
        }

        that.discount = that.$route.query.discount ? that.$route.query.discount : that.loginData.discount

        that.channel = that.$route.query.channel ? that.$route.query.channel : that.loginData.channel
        that.appkey = appkey ? appkey : that.loginData.appkey
        that.uid = that.$route.query.uid ? that.$route.query.uid : that.loginData.uid
        that.appid = appid ? appid : that.loginData.appid

        // 安卓
        if (that.config.system == 1) {
            that.uid = window.Android.getUid()
            that.appUid = window.Android.getCUid()
            that.discount = parseInt(that.discount, 10)
            that.payParams = JSON.parse(window.Android.getPayParams())
            that.origPrice = that.payParams.origPrice
            that.getUser()
            if (!that.discount) that.discount = 0
            if (that.discount == 0 || that.discount == 10) {
                that.amount = that.origPrice
            } else if (that.discount) {
                that.amount = (Math.ceil(that.origPrice * (that.discount / 10) * 100) / 100).toFixed(2)
            }
            that.paymoney = that.amount
        } else if (that.config.system == 2) { // ios
            window.appIosCallback = function (data) {

                let iosInfo = JSON.parse(Base64.decode(data))

                that.channel = iosInfo.getChannel ? iosInfo.getChannel : that.$route.query.channel ? that.$route.query.channel : that.loginData.channel

                that.appkey = iosInfo.getAppKey ? iosInfo.getAppKey : appkey ? appkey : that.loginData.appkey

                that.appid = iosInfo.getAppId ? iosInfo.getAppId : appid ? appid : that.loginData.appid

            }

            window.webkit.messageHandlers.wz_callOC.postMessage({ method: 'getAppInfo' })

            window.IosGetPayParamsCallback = function (data) {
                that.payParams = JSON.parse(Base64.decode(data))
                that.uid = that.payParams.getUid
                that.appUid = that.payParams.getCUid
                that.discount = parseInt(that.payParams.discount, 10)
                that.origPrice = that.payParams.origPrice
                that.getUser()
                if (!that.discount) that.discount = 0
                if (that.discount == 0 || that.discount == 10) {
                    that.amount = that.origPrice
                } else if (that.discount) {
                    that.amount = (Math.ceil(that.origPrice * (that.discount / 10) * 100) / 100).toFixed(2)
                }
                that.paymoney = that.amount
            }
            window.webkit.messageHandlers.wz_callOC.postMessage({ method: 'getPayParams' })
        }

        // 查询支付状态
        if (sessionStorage.getItem('orderID')) {
            that.orderID = sessionStorage.getItem('orderID')
            that.ispay = sessionStorage.getItem('payType')
            that.times = setInterval(() => {
                that.payQuery()
            }, 1000)
        }

    },
    // 离开组件时清除定时器
    destroyed() {
        let that = this
        clearInterval(that.times)
        sessionStorage.removeItem('orderID')
    }
}
</script>

<style lang="scss" scoped>
$color: #FF6C22; // 主体颜色

.pay-box {
    width: 100%;
    height: 100%;
}

// 横屏css
.base-yx-pay {
    width: 1080px;
    height: 100%;
    padding-bottom: 60px;
    background: rgba(0, 0, 0, 0.8);
    display: flex;
    flex-direction: column;

    .content {
        flex: 1;
        display: flex;
        flex-direction: column;
        overflow-y: scroll;

        .header {
            height: 132px;
            background: rgba($color, 0.8);
            display: flex;
            align-items: center;
            justify-content: center;
            position: relative;

            .back-img {
                width: 192px;
                height: 132px;
                position: absolute;
                left: 0;
                display: flex;
                align-items: center;
                justify-content: center;

                .back {
                    width: 72px;
                    height: 72px;
                }
            }

            .title {
                font-size: 51px;
                text-align: center;
            }

            .service-img {
                width: 192px;
                height: 132px;
                position: absolute;
                right: 0;
                display: flex;
                align-items: center;
                justify-content: center;

                .ser {
                    width: 72px;
                    height: 72px;
                }
            }
        }

        .content-auto {
            flex: 1;
            overflow-y: scroll;
            padding: 60px;

            .pay-info {
                height: 470px;
                border-radius: 18px;
                background: rgba(255, 255, 255, 0.2);
                margin-bottom: 30px;
                display: flex;
                flex-direction: column;
            }

            .pay-info .money {
                flex: 1;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 36px;
            }

            .pay-info .money span {
                color: $color;
            }

            .pay-info .money .num {
                font-size: 60px;
            }

            .pay-info .info {
                min-height: 315px;
                border-radius: 18px;
                margin: 0 45px 30px;
                overflow: hidden;
            }

            .pay-info .info .list {
                height: 105px;
                background: rgba(0, 0, 0, 0.2);
                padding: 0 45px;
                display: flex;
                justify-content: space-between;
                align-items: center;
            }

            .pay-info .info .list:last-child {
                border-bottom: 0;
            }

            .pay-info .info .list .left {
                font-size: 42px;
            }

            .pay-info .info .list .right {
                font-size: 36px;
            }

            .pay-info .info .list .right .productName {
                max-width: 520px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }

            .pay-info .info .list .right:last-child {
                display: flex;
                align-items: center;

                img {
                    width: 36px;
                    height: 36px;
                    margin-left: 20px;
                }
            }

            .voucher {
                color: rgba(255, 255, 255, 0.5);
            }

            .card {
                height: 150px;
                background: linear-gradient(90deg, #4D4745, #2F2F31);
                border-radius: 18px;
                display: flex;

                .name {
                    width: 72px;
                    height: 150px;
                    color: #66462B;
                    font-size: 33px;
                    background: linear-gradient(90deg, #F3D9BB, #D5A169);
                    border-radius: 18px 0px 0px 18px;
                    writing-mode: tb-rl;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }

                .info {
                    flex: 1;
                    display: flex;
                    justify-content: space-between;
                    padding: 0 45px 0 29px;
                }

                .info-left {
                    color: #FFE7BA;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                }

                .info-left .title {
                    font-size: 45px;
                    margin-bottom: 10px;
                }

                .info-left .sub {
                    font-size: 33px;
                }

                .info-right {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }

                .info-right .money {
                    color: $color;
                    font-size: 36px;
                }

                .info-right .money span {
                    font-size: 60px;
                }

                .info-right .sel {
                    width: 60px;
                    height: 60px;
                    border: 3px solid #fff;
                    border-radius: 50%;
                    margin-left: 60px;
                    position: relative;
                }

                .info-right .isselbor {
                    border: 0;
                }

                .info-right .sel img {
                    width: 60px;
                    height: 60px;
                    position: absolute;
                    top: -3px;
                    left: -3px;
                }
            }

            .problem {
                font-size: 45px;
                margin: 50px 0 20px;
                display: flex;
                align-items: center;

                .line {
                    width: 12px;
                    height: 24px;
                    background: $color;
                    margin: 5px 19px 0 0;
                }
            }

            .pay-list {
                height: 120px;
                border-radius: 18px;
                background: rgba(255, 255, 255, 0.2);
                padding: 0 45px;
                display: flex;
                align-items: center;
                justify-content: space-between;
            }

            .pay-list:last-child {
                border-bottom: 0;
            }

            .pay-list .no-money {
                font-size: 36px;
                color: rgba(255, 255, 255, 0.5);
            }

            .pay-left {
                font-size: 42px;
                display: flex;
                align-items: center;

                .hscolor {
                    color: rgba(255, 255, 255, 0.5);
                }

                img {
                    width: 72px;
                    height: 72px;
                    margin-right: 30px;
                }
            }

            .pay-right {
                width: 60px;
                height: 60px;
                border: 3px solid #fff;
                border-radius: 50%;
                position: relative;

                img {
                    width: 60px;
                    height: 60px;
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                }
            }

            .isbor {
                border: 0;
            }
        }
    }

    .btn {
        height: 120px;
        font-size: 39px;
        border-radius: 18px;
        background: $color;
        margin: 0 60px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
}

// 竖屏css
.yxpay-sp {
    width: 82%;
    height: 80%;
    border-radius: 60px 0 0 0;
    overflow: hidden;
    padding-bottom: 90px;
    position: absolute;
    right: 0;
    bottom: 0;

    .content {
        .header {
            height: 240px;
            border-radius: 60px 0 0 0;

            .back-img {
                width: 290px;
                height: 240px;

                .back {
                    width: 130px;
                    height: 130px;
                }
            }

            .title {
                font-size: 92px;
            }

            .service-img {
                width: 290px;
                height: 240px;

                .ser {
                    width: 130px;
                    height: 130px;
                }
            }
        }

        .content-auto {
            padding: 90px;

            .pay-info {
                height: 854px;
                border-radius: 32px;
                margin-bottom: 54px;
            }

            .pay-info .money {
                font-size: 65px;
            }

            .pay-info .money .num {
                font-size: 109px;
            }

            .pay-info .info {
                min-height: 572px;
                border-radius: 32px;
                margin: 0 81px 54px;
            }

            .pay-info .info .list {
                height: 190px;
                padding: 0 70px;
            }

            .pay-info .info .list .left {
                font-size: 70px;
            }

            .pay-info .info .list .right {
                font-size: 65px;
            }

            .pay-info .info .list .right .productName {
                max-width: 680px;
            }

            .pay-info .info .list .right:last-child {
                img {
                    width: 65px;
                    height: 65px;
                    margin-left: 36px;
                }
            }

            .card {
                height: 272px;
                border-radius: 32px;

                .name {
                    width: 130px;
                    height: 272px;
                    font-size: 60px;
                    border-radius: 32px 0px 0px 32px;
                }

                .info {
                    padding: 0 81px 0 40px;
                }

                .info-left .title {
                    font-size: 70px;
                    margin-bottom: 18px;
                }

                .info-left .sub {
                    font-size: 50px;
                }

                .info-right .money {
                    font-size: 60px;
                }

                .info-right .money span {
                    font-size: 80px;
                }

                .info-right .sel {
                    width: 90px;
                    height: 90px;
                    border: 5px solid #fff;
                    margin-left: 50px;
                }

                .info-right .isselbor {
                    border: 0;
                }

                .info-right .sel img {
                    width: 90px;
                    height: 90px;
                    position: absolute;
                    top: -5px;
                    left: -5px;
                }
            }

            .problem {
                font-size: 81px;
                margin: 90px 0 36px;

                .line {
                    width: 21px;
                    height: 43px;
                    margin: 9px 34px 0 0;
                }
            }

            .pay-list {
                height: 200px;
                border-radius: 32px;
                padding: 0 81px;
            }

            .pay-list .no-money {
                font-size: 60px;
            }

            .pay-left {
                font-size: 70px;

                img {
                    width: 120px;
                    height: 120px;
                    margin-right: 54px;
                }
            }

            .pay-right {
                width: 90px;
                height: 90px;
                border: 5px solid #fff;

                img {
                    width: 90px;
                    height: 90px;
                }
            }

            .isbor {
                border: 0;
            }
        }
    }

    .btn {
        height: 200px;
        font-size: 70px;
        border-radius: 32px;
        margin: 0 90px;
    }
}
</style>